/* eslint-disable max-classes-per-file */
import BlockComponentImage from '../../../../models/BlockComponentValues/BlockComponentImage';
import LinkData from '../../../../models/LinkData';

class BlockHeaderLogoMenuData {
  logo?: BlockComponentImage;
  menus?: LinkData[];
  url?: BlockComponentImage;
  isFree: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockHeaderLogoMenuData {
  export function make(isFree?: boolean, logo?: string, menus?: LinkData[], url?: string): BlockHeaderLogoMenuData {
    return {
      isFree,
      logo: BlockComponentImage.make(logo),
      menus,
      url: BlockComponentImage.make(url),
    };
  }

  export function getDefault(isFree = false, logo = ''): BlockHeaderLogoMenuData {
    return make(
      isFree,
      logo,
      [
        LinkData.getDefault('メニュー1'),
        LinkData.getDefault('メニュー2'),
        LinkData.getDefault('メニュー3'),
      ],
    );
  }
}

export default BlockHeaderLogoMenuData;
